import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 73F67174-7800-44CB-9850-61A01F9DAD34
 * name monitor-off
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-off.svg
 * tags
 * - Device / Tech 
 */
export const MonitorOffIcon = createSvgIcon(<><path d="M14,18V20H16V22H8V20H10V18H3A2,2 0 0,1 1,16V4L0,3L1.41,1.58L22.16,22.34L20.75,23.75L15,18H14M3,16H13L3,6V16M21,2A2,2 0 0,1 23,4V16A2,2 0 0,1 21,18H20.66L18.66,16H21V4H6.66L4.66,2H21Z" /></>, 'MonitorOffIcon');
export default MonitorOffIcon